import React from "react";
import { motion } from "framer-motion";
import FeedbackStepLayout from "../FeedbackStepLayout";
import { ReactComponent as RoadmapIcon } from "../../../../../../../../assets/icons/Roadmap.svg";

const Step6Finish = ({ onSubmit, onClose, prevStep, data }) => {
  const handleFinish = () => {
    // 🚀 Send the full feedback data to parent
    if (onSubmit) onSubmit(data);
    // 🧩 Close modal
    if (onClose) onClose();
  };

  return (
    <FeedbackStepLayout
      step={6}
      totalSteps={6}
      onBack={prevStep}
      onClose={handleFinish}
      isLast
    >
      <div className="flex flex-col items-center justify-center h-full gap-10">

        {/* === Roadmap SVG Reveal Animation === */}
        <motion.div
          className="w-36 h-36 flex items-center justify-center"
          initial={{ opacity: 0, scale: 0.85, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
        >
          <motion.div
            initial="hidden"
            animate="visible"
            variants={{
              hidden: {},
              visible: {
                transition: { staggerChildren: 0.1, delayChildren: 0.4 },
              },
            }}
          >
            <RoadmapIcon className="w-full h-full text-sky-600">
              <motion.path
                variants={{
                  hidden: { pathLength: 0, opacity: 0 },
                  visible: {
                    pathLength: 1,
                    opacity: 1,
                    transition: {
                      duration: 4,
                      ease: "easeInOut",
                    },
                  },
                }}
              />
            </RoadmapIcon>
          </motion.div>

          {/* ✨ Subtle glow fade */}
          <motion.div
            className="absolute inset-0 rounded-full bg-sky-300/20 blur-3xl"
            animate={{ opacity: [0, 0.5, 0] }}
            transition={{
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />
        </motion.div>

        {/* === Completion Message === */}
        <motion.div
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 3, duration: 1 }}
          className="w-64 text-center text-neutral-600 text-xl font-semibold font-['Inter'] leading-snug"
        >
          Another chapter in your story has been recorded!
        </motion.div>
      </div>
    </FeedbackStepLayout>
  );
};

export default Step6Finish;
